import type { ReactNode } from 'react';
import { useAuth } from '@/context/AuthContext';
import type { Role } from '@flock-types/auth.types';

const ROLE_RANK: Record<Role['role'], number> = {
  org_admin: 5,
  campus_pastor: 4,
  ministry_director: 3,
  group_leader: 2,
  group_member: 1,
};

/** True when the current role is at or above the given role in the hierarchy. */
export function hasRoleAtLeast(current: Role['role'] | null, min: Role['role']): boolean {
  if (!current) return false;
  return ROLE_RANK[current] >= ROLE_RANK[min];
}

interface RoleGateProps {
  /** Minimum role required to render children (hierarchy-aware). */
  minRole: Role['role'];
  children: ReactNode;
  fallback?: ReactNode;
}

export default function RoleGate({ minRole, children, fallback = null }: RoleGateProps) {
  const { role } = useAuth();
  return hasRoleAtLeast(role, minRole) ? <>{children}</> : <>{fallback}</>;
}
